export enum BuilderType {
  BUGGIES,
  ROLLS
}
